<template>
<div class="chapter">
<div class="inner_page">
<a id="page_14">
<h2 class="fm_titlea">About Time</h2>
</a><p class="noindent"><a id="page_14">Before the late 18th century, the biggest problem affecting mariners sailing the seas was finding their position. </a><span href="#/xhtml/48_Glossary#gloss-42" id="gloss_42" title="Link target outside of Sample">Latitude</span> was easily determined by observing the <span href="#/xhtml/48_Glossary#gloss-1" id="gloss_1" title="Link target outside of Sample">altitude</span> of the pole star above the northern <span href="#/xhtml/48_Glossary#gloss-38" id="gloss_38" title="Link target outside of Sample">horizon</span>. Longitude, however, was far more difficult to measure. The inability of mariners to determine their longitude often led to them getting lost, and on many occasions shipwrecked. To address this problem King Charles II established the Royal Observatory at Greenwich in 1675 and from here, Astronomers Royal began the process of measuring and cataloguing the stars as they passed due south across the Greenwich <span href="#/xhtml/48_Glossary#gloss-51" id="gloss_51" title="Link target outside of Sample">meridian</span>.</p>
<p class="indent">Now mariners only needed an accurate timepiece (the chronometer invented by Yorkshire-born clockmaker John Harrison) to display GMT (Greenwich Mean Time). Working out the local standard time onboard ship and subtracting this from GMT gave the ship’s longitude (west or east) from the Greenwich meridian. Therefore mariners always knew where they were at sea and the longitude problem was solved.</p>
<p class="indent">Astronomers use a time scale called Universal Time (UT). This is equivalent to Greenwich Mean Time and is defined by the rotation of the Earth. The Yearbook of Astronomy gives all times in UT rather than in the local time for a particular city or country. Times are expressed using the 24-hour clock, with the day beginning at midnight, denoted by 00:00. Universal Time (UT) is related to local mean time by the formula:</p>
<p class="noindent1">Local Mean Time = UT – west longitude</p>
<p class="noindent1">In practice, small differences in longitude are ignored and the observer will use local clock time which will be the appropriate Standard (or Zone) Time. As the formula indicates, places in west longitude will have a Standard Time slow on UT, while those in east longitude will have a Standard Time fast on UT. As examples we have:</p>
<a id="page_15">
<p class="noindentb">Standard Time in</p>
<table class="table2">
<tbody><tr>
<td class="wd1">New Zealand</td>
<td class="wd2">UT +12 hours</td>
</tr>
<tr>
<td class="wd1">Victoria, NSW</td>
<td class="wd2">UT +10 hours</td>
</tr>
<tr>
<td class="wd1">Western Australia</td>
<td class="wd2">UT + 8 hours</td>
</tr>
<tr>
<td class="wd1">South Africa</td>
<td class="wd2">UT + 2 hours</td>
</tr>
<tr>
<td class="wd1">British Isles</td>
<td class="wd2">UT</td>
</tr>
<tr>
<td class="wd1">Eastern Standard Time</td>
<td class="wd2">UT –5 hours</td>
</tr>
<tr>
<td class="wd1">Central Standard Time</td>
<td class="wd2">UT –6 hours</td>
</tr>
<tr>
<td class="wd1">Pacific Standard Time</td>
<td class="wd2">UT –8 hours</td>
</tr>
</tbody></table>
<p class="noindent1">During the periods when Summer Time (also called Daylight Saving Time) is in use, one hour must be added to Standard Time to obtain the appropriate Summer/Daylight Saving Time. For example, Pacific Daylight Time is UT –7 hours.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_About.vue?7ea058d5